export default __webpack_public_path__ + "static/media/my.ac920fd6.svg";